const forms = [
  {
    name: "Teams",
    options: [
      // {
      //   name: "Image (Recomended 305 x 320)",
      //   type: "input",
      //   form: {
      //     type: "file",
      //     accept: "image/jpeg, image/jpg, image/png",
      //     name: "image",
      //     placeholder: "",
      //     class: "",
      //     value: "",
      //     required: true,
      //   },
      // },
      {
        name: "Image",
        type: "upload",
        form: {
          type: "text",
          name: "image",
          placeholder: "Recomended (305 X 320)",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Name",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Designation",
        type: "input",
        form: {
          type: "text",
          name: "designation",
          placeholder: "Designation",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Phone",
        type: "input",
        form: {
          type: "text",
          name: "phone",
          placeholder: "Phone",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Email",
        type: "input",
        form: {
          type: "text",
          name: "email",
          placeholder: "Email",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Description",
        type: "input",
        form: {
          type: "text",
          name: "description",
          placeholder: "Description",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
